export default "__VITE_ASSET__C2T090_Z__"